import { store } from "./store";
import { Layout, setLayout } from "./state/pages";

const installMediaQueryWatcher = (mediaQuery: string, layoutChangedCallback: (mediaQueryMatches: boolean) => void) => {
    let mql = window.matchMedia(mediaQuery);
    mql.addEventListener("change", (e) => layoutChangedCallback(e.matches));
    layoutChangedCallback(mql.matches);
};

export const setupLayoutListeners = () => {
    installMediaQueryWatcher('(max-width: 650px)',
        (matches) => {
            if (matches) {
                console.info('media query detected PHONE view');
                store.dispatch(setLayout(Layout.PHONE));
            }
        });
    installMediaQueryWatcher('(min-width: 651px) and (max-width: 1024px)',
        (matches) => {
            if (matches) {
                console.info('media query detected TABLET view');
                store.dispatch(setLayout(Layout.TABLET));
            }
        });
    installMediaQueryWatcher('(min-width: 1025px) and (max-width: 1920px)',
        (matches) => {
            if (matches) {
                console.info('media query detected LAPTOP view');
                store.dispatch(setLayout(Layout.LAPTOP));
            }
        });
    installMediaQueryWatcher('(min-width: 1921px)',
        (matches) => {
            if (matches) {
                console.info('media query detected DESKTOP view');
                store.dispatch(setLayout(Layout.DESKTOP));
            }
        });
}

export const switchLayout = (layout: Layout, phoneValue: any, tabletValue: any, laptopValue: any, desktopValue: any) => {
    switch (layout) {
        case Layout.PHONE:
            return phoneValue;
        case Layout.TABLET:
            return tabletValue;
        case Layout.LAPTOP:
            return laptopValue;
        case Layout.DESKTOP:
            return desktopValue;
        default:
            return phoneValue;
    };
}

